import { Box } from '@mui/material';

const visuallyHiddenSx = {
  position: 'fixed' as const,
  top: 0,
  left: 0,
  width: 1,
  height: 1,
  margin: -1,
  padding: 0,
  overflow: 'hidden',
  clip: 'rect(0, 0, 0, 0)',
  whiteSpace: 'nowrap' as const,
  border: 0,
};

export type WidgetLivePoliteness = 'polite' | 'assertive';

interface WidgetLiveRegionProps {
  message: string;
  politeness: WidgetLivePoliteness;
  /** BCP 47 tag for catalog announcements; omit for untranslated content. */
  lang?: string;
}

export function WidgetLiveRegion({ message, politeness, lang }: WidgetLiveRegionProps) {
  return (
    <Box
      // Politeness is fixed for the lifetime of a region. `role="status"` implies
      // polite, so pairing it with `aria-live="assertive"` made screen readers
      // fall back to the role and drop urgent messages such as "Service
      // unavailable"; assertive announcements need `role="alert"` instead.
      role={politeness === 'assertive' ? 'alert' : 'status'}
      aria-live={politeness}
      aria-atomic="true"
      // Only set when provided so a prior catalog announcement cannot leave
      // `lang` stuck on the region for a following untranslated message.
      {...(lang ? { lang } : {})}
      sx={visuallyHiddenSx}
    >
      {message}
    </Box>
  );
}
